import { Box, Typography } from "@mui/material";
import { DashboardRefreshControl } from "../../components/DashboardRefreshControl";

type StudentDashboardHeaderProps = {
  studentName: string;
  lastUpdatedLabel: string;
  refreshing: boolean;
  onRefresh: () => Promise<void>;
};

const greetingForHour = (hour: number) => {
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

// Same plain page header as the admin dashboard: bold greeting, quiet date line, no card around it.
export const StudentDashboardHeader = ({ studentName, lastUpdatedLabel, refreshing, onRefresh }: StudentDashboardHeaderProps) => {
  const today = new Date().toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
        pt: { xs: 1, md: 1.5 },
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="h1"
          sx={{ fontSize: { xs: "1.4rem", md: "1.75rem" }, fontWeight: 800, letterSpacing: "-0.02em", color: "#0f172a", lineHeight: 1.2 }}
        >
          {greetingForHour(new Date().getHours())}, {studentName}
        </Typography>
        <Typography sx={{ fontSize: { xs: 13.5, md: 14.5 }, color: "text.secondary", mt: 0.75 }}>
          {today}
        </Typography>
      </Box>

      <DashboardRefreshControl lastUpdatedLabel={lastUpdatedLabel} refreshing={refreshing} onRefresh={onRefresh} />
    </Box>
  );
};
